<template>
    <div>
        <b-modal id="extension-request"
            centered title="Request Extension"
            :ok-title="submitTitle"
            @shown="checkExtensionRequests()"
            @ok="overdue ? openCase() : requestExtension()"
            :ok-variant="canSubmit"
            :ok-disabled="submitDisabled"
            cancel-variant="link"
            ref="modalExtensionRequest">
            <div class="row">
                <div class="col">
                    <div v-if="pendingRequest">
                        <p>You have a pending extension request under review by our accounts department.</p>
                    </div>
                    <div v-else-if="overdue">
                        <p>
                            <span class="sau-font-bold">Extension request unavailable.</span>
                        </p>
                        <p>You cannot request an extension for an overdue invoice.</p>
                    </div>
                    <div v-else>
                        <div> 
                            <p>
                                <span class="sau-font-bold">
                                    <template v-if="requests === 0">
                                        You have not previously requested an extension for this account.
                                    </template>
                                    <template v-if="requests === 1">
                                        You have placed 1 previous extension request.
                                    </template>
                                    <template v-else-if="requests > 1">
                                        You have placed {{ requests }} previous extension requests and are no longer eligible for automatic approval.
                                    </template>
                                </span>
                            </p>
                            <p>Servers Australia customers are eligible for <span class="sau-font-bold">TWO</span> automatic invoice extensions on their account:</p>
                            <ul>
                                <li>A 14 day automatic extension will be applied to an invoice on your first request.</li>
                                <li>A 7 day automatic extension will be applied to an invoice on your second request.</li>
                            </ul>
                            <p>Any subsequent invoice extension requests for your account will be forwarded to our accounts department for review.</p>

                            <template v-if="requests > 1">
                                <p><span class="sau-font-bold">Please provide the reason for your extension request below.</span></p>
                                <textarea v-model="requestReason" class="form-control" rows="5" maxlength="200" />
                                <p class="text-caption text-right small" :class="{ 'text-danger':requestReason.length < 50, 'text-success':requestReason.length >= 50 }">{{ requestReason.length }} / 200 (min. 50 characters)</p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    // props: ['invoice'],
    data() {
        return {
            requests: '',
            requestReason: '',
            pendingRequest: false,
            error: `<div class="text-center">
                                        <img src="/img/apiro-broken.gif" class="mx-auto"/>
                                        <h5 class="sau-pm-reset">There was an issue processing your request.</h5>
                                        <p>Please try again soon.</p>
                                    </div>`
        }
    },
    created() {
        this.startApp();
    },

    computed: {
        overdue() {
          return (this.invoice.status === 'Unpaid' && moment(new Date).isAfter(this.invoice.duedate));  
        },
        submitDisabled() {
            return (!this.overdue) 
                && (this.pendingRequest || (this.requestReason.length < 50 && this.requests > 1));
        },
        canSubmit() {
            return this.submitDisabled ? 'disabled' : 'success';
        },
        submitTitle() {
            return this.overdue ? 'Open a Support Case' : 'Submit Extension Request';
        }
    },

    methods: {
        startApp() {
            this.checkExtensionRequests().then(response => {
                if(response.data) {
                    this.requests = response.data.count;
                    this.pendingRequest = response.data.pendingRequest;
                }
            })
        },
        requestExtension() {
            this.$swal({
                title: "Processing your request",
                text: "Please wait...",
                imageUrl: "/img/spinner-circle-120.gif",
                showConfirmButton: false,
                allowOutsideClick: false
            });
            axios.post('/api/billing/invoices/' + this.invoice.id + '/request-extension', { requestReason: this.requestReason })
            .then(response => {
                this.$swal.close();

                //Check if we recieved a response first
                if(!response.data) {
                    this.$swal({
                        html: this.error,
                        showConfirmButton: true,
                        allowOutsideClick: true,
                        buttonsStyling: false,
                        confirmButtonText: 'Close',
                        confirmButtonClass: 'btn btn-danger'
                    });
                    return;
                }

                if(response.data.result == 'success') {
                    this.requests++;
                    // Prevent a user submitting multiple requests without refreshing
                    let message = 'Your extension request has been submitted!';
                    /** Update the response if the request is subject to manual approval */
                    if(response.data.manual) {
                        message += ' Our Billing Department will contact you after your request has been reviewed';
                        this.pendingRequest = true;
                    } else {
                        /** Automatic approval - update due date */
                        this.invoice.duedate = response.data.date;
                    }

                    this.$swal({
                        type:'success',
                        title: 'Success!',
                        text: message,
                        showConfirmButton: false,
                        timer: 5000
                    });

                    /** Update the due date so the new value is displayed without refreshing the page */
                } else {
                    this.$swal({
                        html: this.error,
                        showConfirmButton: true,
                        allowOutsideClick: true,
                        buttonsStyling: false,
                        confirmButtonText: 'Close',
                        confirmButtonClass: 'btn btn-danger'
                    });
                }
            })
            .catch(error => {
                this.$swal.close();
                this.$swal({
                    html: this.error,
                    showConfirmButton: true,
                    allowOutsideClick: true,
                    buttonsStyling: false,
                    confirmButtonText: 'Close',
                    confirmButtonClass: 'btn btn-danger'
                });
            })
        },

        openCase() {
            window.location.href = '/support/cases/create';
        },
    },
}
</script>